import React from 'react';
import ReactModal from 'react-modal';
import './Modal.css';

ReactModal.setAppElement('#root');

export const ModalHeader = ({ children }) => (
  <div className="modal-header">
    {children}
  </div>
)

export const ModalBody = ({ children }) => (
  <div className="modal-body">
    {children}
  </div>
)

export default ({ children, handleModalClose, className, ...props }) => (
  <ReactModal {...props}  className={`Modal__Content ${className}`} overlayClassName="Modal__Overlay" onRequestClose={() => handleModalClose()}>
    <q-icon name="times" size="lg" onClick={() => handleModalClose()} />
    {children}
  </ReactModal>
);



// WEBPACK FOOTER //
// ./src/components/Modal/index.js